import { ChangeEvent, FocusEvent, InputHTMLAttributes } from "react"
import * as T from "trunx"
import cn from "classnames"
import { SizeProp } from "trunx"

import { Spinner } from "components/Spinner"
import { Icon } from "components"

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    isLoading?: boolean
    hasError?: boolean
    hasSuccess?: boolean
    pendingStatus?: "idle" | "loading" | "success" | "error"
    customSize?: SizeProp
    isDanger?: boolean
    isFocused?: boolean
    isHovered?: boolean
    isRounded?: boolean
    isStatic?: boolean
}

export function Input({
    className,
    pendingStatus = "idle",
    isFocused,
    isDanger,
    customSize,
    children,
    ...props
}: InputProps) {
    const isLoading = pendingStatus === "loading"
    const hasSuccess = pendingStatus === "success"
    const hasError = pendingStatus === "error"

    const handleInput = (event: ChangeEvent<HTMLInputElement>) => {
        event.target.value = event.target.value.trimStart()

        if (props.onInput) {
            props.onInput(event)
        }
    }

    const handleBlur = (event: FocusEvent<HTMLInputElement>) => {
        event.target.value = event.target.value.trimEnd()

        if (props.onBlur) {
            props.onBlur(event)
        }
    }

    return (
        <T.Control hasIconsRight={isLoading}>
            <T.Input
                {...props}
                size={customSize as "small" | "medium" | "large" | undefined}
                autoFocus={hasSuccess || isLoading || isFocused}
                color={hasError || isDanger ? "danger" : undefined}
                className={cn("blm-input", className)}
                onInput={handleInput}
                onBlur={handleBlur}
            />
            {isLoading && <Spinner className="is-small is-inline-block blm-input__spinner" />}
            {hasError && <Icon type="error" />}
            {hasSuccess && <Icon type="done" />}
            {children}
        </T.Control>
    )
}
